/**
 * Wraps a provided dataLayer callback function in some additional checks. Ensures that the
 * callback is only run in response to the dataLayer message being processed by a Google
 * Analytics container, and not other containers. Also sets a 500ms timeout after which the
 * callback will be run if it has not yet been run by GTM.
 * @param {?Function} originalCallback
 * @returns {?Function}
 */
var buildCallback = function buildCallback(originalCallback) {
  if (!originalCallback) return null;

  // GTM will not be running at all if it's blocked by Cookiebot, an ad blocker, or a browser with strong privacy settings.
  // So we register a callback that is fired after 500ms in case GTM never gets to process the event.
  var eventCallbackFallback = setTimeout(originalCallback, 500);
  return function (containerId) {
    // This callback is fired for every "tag" that is registered in Google Tag Manager.
    // e.g. once for Google Analytics, and once for Google Ads.
    // We have to check the container ID starts with "G-" to know it's a Google Analytics callback.
    if (containerId !== null && containerId !== void 0 && containerId.startsWith("G-")) {
      // This fires when the GA event has successfully been recorded.
      // We remove our fallback timer and call the callback function.
      clearTimeout(eventCallbackFallback);
      originalCallback();
    }
  };
};
module.exports = buildCallback;